import { HotkeysTarget2, Icon, MenuItem } from "@blueprintjs/core"
import { Omnibar } from "@blueprintjs/select"
import { useAuthenticatedRoutes } from "hooks/useAuthenticatedRoutes"
import { kebabCase } from "lodash-es"
import React, { useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { VesaRouteType } from "routes"
import mainRoutes from "routes/main.routes"
import "./style.css"

const UniversalSearch = () => {
  const [isOpen, setOpen] = useState(false)
  const navigate = useNavigate()
  const validRoutes = useAuthenticatedRoutes({
    routes: mainRoutes,
  })

  const validItems = useMemo(() => {
    const finalItems = []
    function convertRoutes(routes: VesaRouteType[], parent: any) {
      for (const route of routes) {
        const path = route.path ? `${parent.path}/${route.path}` : parent.path
        const title = route.secondaryTitle || route.title
        const modules = [...parent.modules, title]
        if (route.children) {
          convertRoutes(route.children, {
            ...route,
            path,
            modules,
          })
        } else {
          if (title) {
            finalItems.push({
              title: title,
              path,
              modules,
            })
          }
        }
      }
    }
    convertRoutes(validRoutes, { path: "/d", title: "Dashboard", modules: [] })
    return finalItems
  }, [validRoutes])

  function handleToggle() {
    setOpen(prev => !prev)
  }
  return (
    <HotkeysTarget2
      hotkeys={[
        {
          combo: "shift + s",
          global: true,
          label: "Show Omnibar",
          onKeyDown: handleToggle,
          preventDefault: true,
        },
      ]}
    >
      <Omnibar
        className="top-[10%] left-1/2 -translate-x-1/2 w-[400px] bg-white rounded transition-all universal-search"
        inputProps={{
          className: "input-shadow-none",
          placeholder: "Search by route",
        }}
        itemPredicate={(q, item) => {
          if (!q) return true
          return item.path.includes(kebabCase(q))
        }}
        onItemSelect={item => {
          setOpen(false)
          navigate(item.path)
        }}
        isOpen={isOpen}
        resetOnSelect={true}
        items={validItems}
        noResults={<MenuItem disabled={true} text="No results." />}
        onClose={handleToggle}
        itemRenderer={(item, { handleClick, modifiers }) => {
          return (
            <MenuItem
              active={modifiers.active}
              key={item.path}
              multiline={true}
              text={
                <>
                  <span>{item.title}</span>
                  <br />
                  <small className="text-muted">
                    {item.modules.map((p: string, idx: number) => {
                      return (
                        <span key={p}>
                          {p}
                          {idx !== item.modules.length - 1 && (
                            <Icon icon="caret-right" />
                          )}
                        </span>
                      )
                    })}
                    {item.label}
                  </small>
                </>
              }
              onClick={handleClick}
            />
          )
        }}
      />
    </HotkeysTarget2>
  )
}

export default UniversalSearch
